// @flow
import styled from 'styled-components';

export const Base = styled.div`
    display: flex;
    width: 100%;
`;

export const Label = styled.div`flex: 1 0 auto;`;

export const ToggleContainer = styled.div`
    flex: 0 0 2em;
    font-size: 0.7em;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/action-attribute/attribute-types/checkbox/styles.js